import { gql } from '@/__generated__';

export const GET_DEVICE_CONFIGURATION_FILE_HISTORY = gql(`#graphql
  query GetDeviceConfigurationFileHistory($deviceId: ID!, $pagination: DynamoPaginationInput) {
    device(input: { id: $deviceId }) {
      id
      hardwareConfiguration {
        id
        configurationFileHistory(pagination: $pagination) {
          items {
            fileName
            createdAt
          }
          pageInfo {
            count
            lastEvaluatedKey
          }
        }
      }
    }
  }
`);
